import { CheckCircle, Circle, CircleX, HelpCircle, CircleAlert, Loader, SignalLow, SignalMedium, SignalHigh, Mail, Phone, Video, NotepadText } from "lucide-react";
export const statuses = [
    {
        value: "backlog",
        label: "En attente",
        icon: <HelpCircle size={18} className="text-gray-500" />
    },
    {
        value: "todo",
        label: "Organisé",
        icon: <Circle size={18} className="text-gray-500" />
    },
    {
        value: "in_progress",
        label: "En cours",
        icon: <Loader size={18} className="text-blue-500" />
    },
    {
        value: "done",
        label: "Fait",
        icon: <CheckCircle size={18} className="text-green-500" />
    },
    {
        value: "canceled",
        label: "Annulé",
        icon: <CircleX size={18} className="text-red-500" />
    }
];

export const priorities = [
    {
        label: "Faible",
        value: "low",
        icon: <SignalLow size={18} className="text-blue-500" />
    },
    {
        label: "Moyen",
        value: "medium",
        icon: <SignalMedium size={18} className="text-yellow-500" />
    },
    {
        label: "Haut",
        value: "high",
        icon: <SignalHigh size={18} className="text-orange-500" />
    },
    {
        label: "Urgent",
        value: "urgent",
        icon: <CircleAlert size={18} className="text-red-500" />
    }
];

export const types = [
    {
        label: "Email",
        value: "email",
        icon: <Mail size={18} />
    },
    {
        label: "Appel",
        value: "call",
        icon: <Phone size={18} />
    },
    {
        label: "Meeting",
        value: "meeting",
        icon: <Video size={18} />
    },
    {
        label: "Note",
        value: "note",
        icon: <NotepadText size={18} />
    }
];
